
import { cn } from "../lib/utils";

function Form( { className, ...props } ) {

  return (

    <form

      className={ cn( "flex flex-col gap-6 sm:gap-10 items-center justify-center", className ) }
      
      {...props}

    />

  )
  
}

export { Form }
